import axiosClient from "./axiosClient";

export function generatePaystub(data) {
  return axiosClient.post("/create_new/paystubs", data);
}

export function generateSelectedPaystubs(data) {
  return axiosClient.post("/create_new/paystubs/selected", data);
}

export function voidSelectedPaystubs(data) {
  return axiosClient.post("/void/paystubs/selected", data);
}

export function fetchChecksReview(data) {
  return axiosClient.post("/payroll/checks-review", data);
}

export function generateChecks(data) {
  return axiosClient.post("/checks/generate", data);
}

export function cancelChecks(data) {
  return axiosClient.post("/checks/cancel", data);
}

export function printChecks(data) {
  return axiosClient.post("/checks/print", data);
}

export function validateDirectDeposit(data) {
  return axiosClient.post("/payroll/validate-direct-deposit", data);
}

export function fetchPaymentFiles(data) {
  return axiosClient.post("/payroll/payment-files", data);
}

export function previewPaymentChecks(data) {
  return axiosClient.post("/payroll/payment-preview", data);
}

export function generatePaymentFile(data) {
  return axiosClient.post("/payroll/payment-generate", data);
}

export function previewAchSplit(data) {
  return axiosClient.post("/payroll/payment-ach-preview", data);
}

export function generateAchSplit(data) {
  return axiosClient.post("/payroll/payment-ach-generate", data);
}

export function exportPaymentFile(fileId) {
  return axiosClient.get(`/payroll/payment-export/${fileId}`, {
    responseType: "blob",
  });
}

export function setPaystubEdit(paystubId, edit) {
  return axiosClient.post(`/payroll/paystubs/${paystubId}/edit`, { edit });
}

export function getPaystubDifference(paystubId) {
  return axiosClient.post(`/payroll/paystubs/${paystubId}/difference`);
}

export function generateDifferencePaystub(paystubId) {
  return axiosClient.post(
    `/payroll/paystubs/${paystubId}/generate-difference`
  );
}
